import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          flex-direction: column;\n          & > * + * {\n            margin-top: 0.5rem;\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          flex-direction: row;\n          & > * + * {\n            margin-left: 0.5rem;\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n\n  .avatar-img {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 1rem;\n  }\n\n  .avatar-initials {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 1rem;\n  }\n\n  .avatarGroup-additional {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 1rem;\n    background: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 0.875rem;\n    color: ", ";\n    font-weight: 600;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Children } from 'react';
import styled, { css } from 'styled-components';
var StyledAvatarGroup = styled.div(_templateObject(), function (props) {
  return props.horizontal ? css(_templateObject2()) : css(_templateObject3());
}, function (props) {
  return props.theme.colors.accent1;
}, function (props) {
  return props.theme.colors.foreground;
});

function AvatarGroup(_ref) {
  var children = _ref.children,
      count = _ref.count,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction;

  function renderLimitedChildren() {
    if (count) {
      var totalAmount = Children.toArray(children);
      var amountNotShown = totalAmount.length - count;
      return _jsxs(_Fragment, {
        children: [totalAmount.map(function (child, index) {
          return index < count ? child : null;
        }), _jsxs("span", Object.assign({
          className: "avatarGroup-additional"
        }, {
          children: ["+", amountNotShown]
        }), void 0)]
      }, void 0);
    }

    return children;
  }

  return _jsx(StyledAvatarGroup, Object.assign({
    horizontal: direction === 'horizontal',
    className: "avatarGroup"
  }, {
    children: renderLimitedChildren()
  }), void 0);
}

export default AvatarGroup;